import http from "../helper/http";
import { ILanguage } from "../model/commonModel/language";

const getLanguages = async (): Promise<ILanguage[]> => {
    return await http.get<any,ILanguage[]>("/Languages");
 
};

export default getLanguages;
